import '../css/center_div.css';
function center_div({children}) {

  return (
    <div className="center_div">
      {children}
    </div>
  );
}

export default center_div;